import React from 'react';

const ShippingReturns = () => {
  return (
    <section className="py-4" style={{ background: '#ffffff' }}>
      <div className="container">
        <div className="card border-0 shadow-sm rounded-4 p-4" style={{ background: '#fff' }}>
          <h1
            className="fw-bold mb-3"
            style={{
              fontFamily: "'Playfair Display', serif",
              color: '#2c2c2c',
              fontSize: '1.5rem',
            }}
          >
            Shipping, Returns &amp; Refunds Policy
          </h1>

          <p style={{ fontSize: '.96rem', color: '#4a3e19' }}>
            At Zoteya Beauty, we aim to deliver a seamless, luxury fulfilment experience.
            Please read this policy carefully before placing your order.
          </p>

          <h2 className="mt-3" style={{ fontSize: '1.1rem', color: '#2c2c2c' }}>
            1. Order Processing &amp; Lead Times
          </h2>
          <p style={{ fontSize: '.95rem', color: '#4a3e19' }}>
            Most items are produced on a pre‑order basis and are custom‑prepared for each client.
            While limited stock may sometimes be available, it is not guaranteed.
          </p>
          <ul style={{ fontSize: '.95rem', color: '#4a3e19' }}>
            <li>Bundles and lace products: estimated 7–10 business days.</li>
            <li>Custom wigs: estimated 10–14 business days.</li>
            <li>Custom colour wigs: an additional ±5 business days may apply.</li>
            <li>Lead times include procurement from suppliers and in‑house preparation and refinement.</li>
            <li>Orders may be completed sooner if stock is available, but all purchases should be made with the full lead time in mind.</li>
          </ul>

          <h2 className="mt-3" style={{ fontSize: '1.1rem', color: '#2c2c2c' }}>
            2. Delivery Options
          </h2>
          <ul style={{ fontSize: '.95rem', color: '#4a3e19' }}>
            <li>In‑store collection (default option).</li>
            <li>Local courier delivery (where selected at checkout).</li>
            <li>Courier delivery may add up to 10 business days to overall turnaround time.</li>
            <li>Once a parcel is handed to the courier, delays in transit are outside our control.</li>
          </ul>

          <h2 className="mt-3" style={{ fontSize: '1.1rem', color: '#2c2c2c' }}>
            3. Delivery Liability
          </h2>
          <ul style={{ fontSize: '.95rem', color: '#4a3e19' }}>
            <li>Clients are responsible for ensuring that all delivery details provided at checkout are accurate and complete.</li>
            <li>Zoteya Beauty is not liable for delays, losses, or failed deliveries due to incorrect addresses or courier errors.</li>
            <li>If a parcel is marked as delivered but not received, clients must contact the courier directly for investigation.</li>
          </ul>

          <h2 className="mt-3" style={{ fontSize: '1.1rem', color: '#2c2c2c' }}>
            4. Refunds for Delayed Delivery
          </h2>
          <p style={{ fontSize: '.95rem', color: '#4a3e19' }}>
            In rare cases where an order is not delivered within the stipulated timeframe and you must secure an alternative solution, we will honour a 100% refund, less:
          </p>
          <ul style={{ fontSize: '.95rem', color: '#4a3e19' }}>
            <li>a 5% transaction processing fee, and</li>
            <li>any applicable shipping or courier charges.</li>
          </ul>

          <h2 className="mt-3" style={{ fontSize: '1.1rem', color: '#2c2c2c' }}>
            5. Returns &amp; Refunds
          </h2>
          <p style={{ fontSize: '.95rem', color: '#4a3e19' }}>
            Returns and refunds are only accepted where all of the following conditions are met:
          </p>
          <ul style={{ fontSize: '.95rem', color: '#4a3e19' }}>
            <li>The item is unused, unwashed, and untampered with.</li>
            <li>Lace remains uncut, unaltered, and intact.</li>
            <li>The product is returned in its original packaging.</li>
            <li>The return request is submitted within 7 days of confirmed courier delivery.</li>
          </ul>
          <p style={{ fontSize: '.95rem', color: '#4a3e19' }}>
            If these conditions are satisfied, a full refund will be issued, less:
          </p>
          <ul style={{ fontSize: '.95rem', color: '#4a3e19' }}>
            <li>a 5% transaction processing fee, and</li>
            <li>any delivery or shipping costs already incurred.</li>
          </ul>
          <p style={{ fontSize: '.95rem', color: '#4a3e19' }}>
            Where possible, we will first try to resolve the issue or offer a suitable replacement.
            If no resolution is reached, the refund will be processed according to this policy.
          </p>
          <p style={{ fontSize: '.95rem', color: '#4a3e19' }}>
            Orders placed without reviewing the stated lead times remain subject to the standard returns policy.
          </p>

          <h2 className="mt-3" style={{ fontSize: '1.1rem', color: '#2c2c2c' }}>
            6. Exchanges
          </h2>
          <ul style={{ fontSize: '.95rem', color: '#4a3e19' }}>
            <li>Due to the custom and made‑to‑order nature of our products, immediate exchanges are not guaranteed.</li>
            <li>If an exchange is approved, it will be processed as a new order.</li>
            <li>Standard turnaround times will apply to all exchange orders.</li>
          </ul>

          <h2 className="mt-3" style={{ fontSize: '1.1rem', color: '#2c2c2c' }}>
            7. Custom Colour Adjustments
          </h2>
          <ul style={{ fontSize: '.95rem', color: '#4a3e19' }}>
            <li>Minor colour variations can occur due to lighting, screen settings, and device displays.</li>
            <li>If the final colour clearly does not match the reference image provided, Zoteya Beauty will correct the colour at no additional cost.</li>
            <li>If the colour matches your reference but you are still unhappy, further adjustments can be requested at an additional fee.</li>
          </ul>

          <h2 className="mt-3" style={{ fontSize: '1.1rem', color: '#2c2c2c' }}>
            8. Custom Wig References &amp; Expectations
          </h2>
          <ul style={{ fontSize: '.95rem', color: '#4a3e19' }}>
            <li>Please avoid sending multiple or conflicting reference images for one custom wig.</li>
            <li>If unsure about your desired look, we recommend booking a consultation before placing your order.</li>
            <li>Clear alignment on the reference before production reduces the risk of dissatisfaction and supports outstanding results.</li>
          </ul>

          <p className="mt-3" style={{ fontSize: '.95rem', color: '#4a3e19' }}>
            Thank you for choosing Zoteya Beauty. These policies help us operate with transparency and deliver a luxury standard of craftsmanship and service.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ShippingReturns;

